module.exports = __webpack_public_path__ + "img/DJ.02e75e20.svg";